import { dirname, resolve } from "path";
import { fileURLToPath } from "url";

const __dirname = dirname(fileURLToPath(import.meta.url));
const platformNodeProxyWsTunnel = resolve(__dirname, "../../platform/src/node-proxy-ws-tunnel.ts");

const mod = await import(platformNodeProxyWsTunnel);

export const createNodeProxyWsTunnelUpgradeResponse = mod.createNodeProxyWsTunnelUpgradeResponse;
export const handleNodeProxyWsTunnelOpen = mod.handleNodeProxyWsTunnelOpen;
export const handleNodeProxyWsTunnelMessage = mod.handleNodeProxyWsTunnelMessage;
export const handleNodeProxyWsTunnelClose = mod.handleNodeProxyWsTunnelClose;
